<canvas #canvas></canvas>
<div>
  <button type="button" ion-button (click)="clear()">
    {{ "IFQ.SIGN_WIDGET.ClEAR_BTN" | transloco }}
  </button>
</div>
